import PropTypes from 'prop-types';
import {useSelector, useDispatch} from 'react-redux';
import {I18n} from 'react-redux-i18n';

import {COUNTRY} from 'front-onceforall-core/dist/utils/country';

import appConfig from '../../../config';

import {recordGAEvent} from '../../utils/analytics';
import {toggleDiscoverVitrineBox} from '../../actions/display';

import {useDossierCountry} from '../organisationDashboard/OrganisationDashboardContainer';
import {pathResolver} from '../../utils/basePathHelper';

function ToggleVitrineBoxButton(props) {
  const [organisation = {}, isBoxShown] = useSelector(state => {
    const {organisationId} = state.organisation;
    const {showDiscoverVitrineBox = false} = state.display?.[organisationId] || {};
    return [state.organisation, showDiscoverVitrineBox];
  });
  const dispatch = useDispatch();
  const dossierCountry = useDossierCountry();

  function gaEventToggleVitrineBox() {
    recordGAEvent('Vitrine', `${isBoxShown ? 'Hide from icon' : 'Show'} discover Vitrine box on ${props.dashboard ? 'Dashboard' : 'Documents'}`);
  }

  if (
    !appConfig?.featureFlags?.showAccessVitrineButton ||
    !organisation.depositor ||
    !organisation.enabled ||
    dossierCountry !== COUNTRY.FRANCE
  ) {
    return null;
  }

  return (
    <button
      onClick={() => {
        dispatch(toggleDiscoverVitrineBox(organisation.organisationId));
        gaEventToggleVitrineBox();
      }}
      className="button-square px-1 flex-container mr-3"
      title={I18n.t('menu.vitrine')}
    >
      <img
        alt="icon vitrine"
        src={pathResolver('resources/img/icon_vitrine.png')}
        style={{width: '40px'}}
      />
    </button>
  );
}

ToggleVitrineBoxButton.defaultProps = {
  dashboard: false
};

ToggleVitrineBoxButton.propTypes = {
  dashboard: PropTypes.bool
};

export default ToggleVitrineBoxButton;
